module.exports = __webpack_public_path__ + "img/fi.367d688f.svg";